import { z } from 'zod'

const responseData = z.object({
  data: z.object({
    token: z.string(),
    expirationDate: z.string()
  })
})

type ResponseWithToken = z.infer<typeof responseData>

export const isResponseWithToken = (obj: unknown): obj is ResponseWithToken =>
  responseData.safeParse(obj).success
